export default __webpack_public_path__ + "static/logo-apgsga-68112c781be5dd9086bef565828aee06.png";